export enum ReRunType {
  NONE = 'NONE',
  ALL_TESTS = 'ALL_TESTS',
  ONLY_FAILED_TESTS = 'ONLY_FAILED_TESTS',
  ALL_ITERATIONS = 'ALL_ITERATIONS',
  ONLY_FAILED_ITERATIONS = 'ONLY_FAILED_ITERATIONS',
  ONLY_FAILED_ITERATIONS_IN_FAILED_TESTS = 'ONLY_FAILED_ITERATIONS_IN_FAILED_TESTS',
  USER_PICKED = 'USER_PICKED',
}
